import { render, staticRenderFns } from "./transformer.vue?vue&type=template&id=5491639d&"
import script from "./transformer.vue?vue&type=script&lang=js&"
export * from "./transformer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports